export enum IOrderFields {
    Name = 'Name',
    Description = 'Description',
    Image = 'Image',
}

export interface IDeleteEventForm {
    eventId?: number;
}
